import { ReservationTimeFrameProps } from 'types/med'

export type ReservationFramesSettingValues = ReservationTimeFrameProps[]

export function addHourString(string: string, amount: number): string {
  return `0${Number(string) + amount}`.slice(-2)
}

function hasBefore15Min(
  value: ReservationFramesSettingValues,
  start_time: string
): boolean {
  return !!value.find(({ end_time }) => start_time === end_time)
}

function getNext15MInNumberOfPeople(
  value: ReservationFramesSettingValues,
  end_time: string
): number {
  const next = value.find(({ start_time }) => start_time === end_time)
  return next ? next.number_of_people : 0
}

export function reservationFrames30To15(
  frames: ReservationTimeFrameProps[],
  maxNumber: number = 10
): ReservationTimeFrameProps[] {
  return frames.map((v) => {
    let number = v.number_of_people
    if (number > maxNumber) {
      number = maxNumber
    }
    const [endHour, endMin]: [string, string] = v.end_time.split(':') as [
      string,
      string
    ]
    switch (endMin) {
      case '00':
        return {
          ...v,
          number_of_people: number,
          end_time: [addHourString(endHour, -1), '45'].join(':'),
        }
      case '30':
        return {
          ...v,
          number_of_people: number,
          end_time: [endHour, '15'].join(':'),
        }
      default:
        return v
    }
  })
}

export function reservationFramesArray30To15<
  T extends { reservation_frames: ReservationTimeFrameProps[] }
>(arr: T[]): T[] {
  return arr.map(
    ({ reservation_frames, ...props }) =>
      ({
        ...props,
        reservation_frames: reservationFrames30To15(reservation_frames),
      } as T)
  )
}

export function reservationFrames15To30(
  frames: ReservationTimeFrameProps[]
): ReservationTimeFrameProps[] {
  return frames
    .map((v) => {
      const { start_time, end_time, number_of_people } = v
      const [startHour, startMin] = start_time.split(':')
      const [endHour] = end_time.split(':')
      const number =
        number_of_people + getNext15MInNumberOfPeople(frames, end_time)
      switch (startMin) {
        case '00':
          return {
            ...v,
            number_of_people: number,
            end_time: [endHour, '30'].join(':'),
          }
        case '15':
          return {
            ...v,
            start_time: hasBefore15Min(frames, start_time)
              ? start_time
              : [startHour, '00'].join(':'),
          }
        case '30':
          return {
            ...v,
            number_of_people: number,
            end_time: [addHourString(endHour, 1), '00'].join(':'),
          }
        case '45':
          return {
            ...v,
            start_time: hasBefore15Min(frames, start_time)
              ? start_time
              : [startHour, '30'].join(':'),
          }
        default:
          return v
      }
    })
    .filter(({ start_time }) => {
      const [, startMin]: [string, string] = start_time.split(':') as [
        string,
        string
      ]
      switch (startMin) {
        case '00':
          return true
        case '15':
          return false
        case '30':
          return true
        case '45':
          return false
        default:
          return false
      }
    })
}

export function reservationFramesArray15To30<
  T extends { reservation_frames: ReservationTimeFrameProps[] }
>(arr: T[]): T[] {
  return arr.map(
    ({ reservation_frames, ...props }) =>
      ({
        ...props,
        reservation_frames: reservationFrames15To30(reservation_frames),
      } as T)
  )
}
